/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ItemProductSearchFilterPropertyFilterFragmentDoc, ItemProductSearchFilterPropertyFilterResolvedFragmentDoc } from '../templates/templateSearchFilters.generated.js';
export type ItemProductSearchFilterIdFilter_EntitySearchIdFilter_Fragment = { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator };

export type ItemProductSearchFilterIdFilter_EntitySearchIdInFilter_Fragment = { __typename: 'EntitySearchIdInFilter', valueIdIn: Array<string>, operatorIdIn: Types.EntitySearchIdInFilterOperator };

export type ItemProductSearchFilterIdFilterFragment = ItemProductSearchFilterIdFilter_EntitySearchIdFilter_Fragment | ItemProductSearchFilterIdFilter_EntitySearchIdInFilter_Fragment;

export type ItemProductSearchIdFilterFragment = { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator };

export type ItemProductSearchFilterDefinitionsFragment = { __typename: 'ItemProductSearchFilterDefinitions', itemId: string, favouritesFilter?: { __typename: 'EntitySearchBoolFilter', valueBool?: boolean | null, operatorBool: Types.EntitySearchBoolFilterOperator } | { __typename: 'EntitySearchBoolFilterComputed', operatorBool: Types.EntitySearchBoolFilterOperator, expr: string, missingValue: boolean, valueBoolComputed?: boolean | null } | null, productTypeIdFilter?: { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator } | null, supplierIdFilter?: { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator } | { __typename: 'EntitySearchIdInFilter', valueIdIn: Array<string>, operatorIdIn: Types.EntitySearchIdInFilterOperator } | null, brandFilter?: { __typename: 'EntitySearchTextFilter', valueText?: string | null, operatorText: Types.EntitySearchTextFilterOperator } | { __typename: 'EntitySearchTextFilterComputed', operatorText: Types.EntitySearchTextFilterOperator, expr: string, missingValue: boolean, valueTextComputed?: string | null } | { __typename: 'EntitySearchTextInFilter', valueTextIn?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator } | { __typename: 'EntitySearchTextInFilterComputed', operatorTextIn: Types.EntitySearchTextInFilterOperator, expr: string, missingValue: boolean, valueTextInComputed?: Array<string> | null } | null, brandLineFilter?: { __typename: 'EntitySearchTextFilter', valueText?: string | null, operatorText: Types.EntitySearchTextFilterOperator } | { __typename: 'EntitySearchTextFilterComputed', operatorText: Types.EntitySearchTextFilterOperator, expr: string, missingValue: boolean, valueTextComputed?: string | null } | { __typename: 'EntitySearchTextInFilter', valueTextIn?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator } | { __typename: 'EntitySearchTextInFilterComputed', operatorTextIn: Types.EntitySearchTextInFilterOperator, expr: string, missingValue: boolean, valueTextInComputed?: Array<string> | null } | null, listPriceFilter?: { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchNumberBetweenFilterComputed', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, expr: string, missingValue: boolean, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber?: number | null } | { __typename: 'EntitySearchNumberFilterComputed', operatorNumber: Types.EntitySearchNumberFilterOperator, expr: string, missingValue: boolean, valueNumberComputed?: number | null } | null, netPriceFilter?: { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber?: number | null } | null, propertyFilters: Array<{ __typename: 'EntitySearchPropertyFilterBoolFilter', key: string, operatorBool: Types.EntitySearchBoolFilterOperator, valueBool?: boolean | null } | { __typename: 'EntitySearchPropertyFilterBoolFilterComputed', key: string, operatorBool: Types.EntitySearchBoolFilterOperator, expr: string, missingValue: boolean, valueBoolComputed?: boolean | null } | { __typename: 'EntitySearchPropertyFilterBoolInFilter', key: string, operatorBoolIn: Types.EntitySearchBoolInFilterOperator, valueBoolIn?: Array<boolean> | null } | { __typename: 'EntitySearchPropertyFilterBoolInFilterComputed', key: string, operatorBoolIn: Types.EntitySearchBoolInFilterOperator, expr: string, missingValue: boolean, valueBoolInComputed?: Array<boolean> | null } | { __typename: 'EntitySearchPropertyFilterNumberBetweenFilter', key: string, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchPropertyFilterNumberBetweenFilterComputed', key: string, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, expr: string, missingValue: boolean, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchPropertyFilterNumberFilter', key: string, operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber?: number | null } | { __typename: 'EntitySearchPropertyFilterNumberFilterComputed', key: string, operatorNumber: Types.EntitySearchNumberFilterOperator, expr: string, missingValue: boolean, valueNumberComputed?: number | null } | { __typename: 'EntitySearchPropertyFilterNumberInFilter', key: string, operatorNumberIn: Types.EntitySearchNumberInFilterOperator, valueNumberIn?: Array<number> | null } | { __typename: 'EntitySearchPropertyFilterNumberInFilterComputed', key: string, operatorNumberIn: Types.EntitySearchNumberInFilterOperator, expr: string, missingValue: boolean, valueNumberInComputed?: Array<number> | null } | { __typename: 'EntitySearchPropertyFilterTextFilter', key: string, operatorText: Types.EntitySearchTextFilterOperator, valueText?: string | null } | { __typename: 'EntitySearchPropertyFilterTextFilterComputed', key: string, operatorText: Types.EntitySearchTextFilterOperator, expr: string, missingValue: boolean, valueTextComputed?: string | null } | { __typename: 'EntitySearchPropertyFilterTextInFilter', key: string, operatorTextIn: Types.EntitySearchTextInFilterOperator, valueTextIn?: Array<string> | null } | { __typename: 'EntitySearchPropertyFilterTextInFilterComputed', key: string, operatorTextIn: Types.EntitySearchTextInFilterOperator, expr: string, missingValue: boolean, valueTextInComputed?: Array<string> | null }> };

export type ItemProductSearchFilterDefaultsFragment = { __typename: 'ItemProductSearchFilterDefaults', itemId: string, favouritesFilter?: { __typename: 'EntitySearchBoolFilter', valueBool?: boolean | null, operatorBool: Types.EntitySearchBoolFilterOperator } | null, productTypeIdFilter?: { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator } | null, supplierIdFilter?: { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator } | { __typename: 'EntitySearchIdInFilter', valueIdIn: Array<string>, operatorIdIn: Types.EntitySearchIdInFilterOperator } | null, brandFilter?: { __typename: 'EntitySearchTextFilter', valueText?: string | null, operatorText: Types.EntitySearchTextFilterOperator } | { __typename: 'EntitySearchTextInFilter', valueTextIn?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator } | null, brandLineFilter?: { __typename: 'EntitySearchTextFilter', valueText?: string | null, operatorText: Types.EntitySearchTextFilterOperator } | { __typename: 'EntitySearchTextInFilter', valueTextIn?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator } | null, listPriceFilter?: { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber?: number | null } | null, netPriceFilter?: { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber?: number | null } | null, propertyFilters: Array<{ __typename: 'EntitySearchPropertyFilterBoolFilter', key: string, operatorBool: Types.EntitySearchBoolFilterOperator, valueBool?: boolean | null } | { __typename: 'EntitySearchPropertyFilterBoolInFilter', key: string, operatorBoolIn: Types.EntitySearchBoolInFilterOperator, valueBoolIn?: Array<boolean> | null } | { __typename: 'EntitySearchPropertyFilterNumberBetweenFilter', key: string, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchPropertyFilterNumberFilter', key: string, operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber?: number | null } | { __typename: 'EntitySearchPropertyFilterNumberInFilter', key: string, operatorNumberIn: Types.EntitySearchNumberInFilterOperator, valueNumberIn?: Array<number> | null } | { __typename: 'EntitySearchPropertyFilterTextFilter', key: string, operatorText: Types.EntitySearchTextFilterOperator, valueText?: string | null } | { __typename: 'EntitySearchPropertyFilterTextInFilter', key: string, operatorTextIn: Types.EntitySearchTextInFilterOperator, valueTextIn?: Array<string> | null }> };

export type ItemProductSearchFilterPriceFilter_EntitySearchNumberBetweenFilter_Fragment = { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween?: { __typename: 'ValueNumberBetween', min: number, max: number } | null };

export type ItemProductSearchFilterPriceFilter_EntitySearchNumberBetweenFilterComputed_Fragment = { __typename: 'EntitySearchNumberBetweenFilterComputed', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, expr: string, missingValue: boolean, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null };

export type ItemProductSearchFilterPriceFilter_EntitySearchNumberFilter_Fragment = { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber?: number | null };

export type ItemProductSearchFilterPriceFilter_EntitySearchNumberFilterComputed_Fragment = { __typename: 'EntitySearchNumberFilterComputed', operatorNumber: Types.EntitySearchNumberFilterOperator, expr: string, missingValue: boolean, valueNumberComputed?: number | null };

export type ItemProductSearchFilterPriceFilterFragment = ItemProductSearchFilterPriceFilter_EntitySearchNumberBetweenFilter_Fragment | ItemProductSearchFilterPriceFilter_EntitySearchNumberBetweenFilterComputed_Fragment | ItemProductSearchFilterPriceFilter_EntitySearchNumberFilter_Fragment | ItemProductSearchFilterPriceFilter_EntitySearchNumberFilterComputed_Fragment;

export type ItemProductSearchFilterPriceFilterResolved_EntitySearchNumberBetweenFilter_Fragment = { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween?: { __typename: 'ValueNumberBetween', min: number, max: number } | null };

export type ItemProductSearchFilterPriceFilterResolved_EntitySearchNumberFilter_Fragment = { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber?: number | null };

export type ItemProductSearchFilterPriceFilterResolvedFragment = ItemProductSearchFilterPriceFilterResolved_EntitySearchNumberBetweenFilter_Fragment | ItemProductSearchFilterPriceFilterResolved_EntitySearchNumberFilter_Fragment;

export type ItemProductSearchFilterBrandFilter_EntitySearchTextFilter_Fragment = { __typename: 'EntitySearchTextFilter', valueText?: string | null, operatorText: Types.EntitySearchTextFilterOperator };

export type ItemProductSearchFilterBrandFilter_EntitySearchTextFilterComputed_Fragment = { __typename: 'EntitySearchTextFilterComputed', operatorText: Types.EntitySearchTextFilterOperator, expr: string, missingValue: boolean, valueTextComputed?: string | null };

export type ItemProductSearchFilterBrandFilter_EntitySearchTextInFilter_Fragment = { __typename: 'EntitySearchTextInFilter', valueTextIn?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator };

export type ItemProductSearchFilterBrandFilter_EntitySearchTextInFilterComputed_Fragment = { __typename: 'EntitySearchTextInFilterComputed', operatorTextIn: Types.EntitySearchTextInFilterOperator, expr: string, missingValue: boolean, valueTextInComputed?: Array<string> | null };

export type ItemProductSearchFilterBrandFilterFragment = ItemProductSearchFilterBrandFilter_EntitySearchTextFilter_Fragment | ItemProductSearchFilterBrandFilter_EntitySearchTextFilterComputed_Fragment | ItemProductSearchFilterBrandFilter_EntitySearchTextInFilter_Fragment | ItemProductSearchFilterBrandFilter_EntitySearchTextInFilterComputed_Fragment;

export type ItemProductSearchFilterBrandFilterResolved_EntitySearchTextFilter_Fragment = { __typename: 'EntitySearchTextFilter', valueText?: string | null, operatorText: Types.EntitySearchTextFilterOperator };

export type ItemProductSearchFilterBrandFilterResolved_EntitySearchTextInFilter_Fragment = { __typename: 'EntitySearchTextInFilter', valueTextIn?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator };

export type ItemProductSearchFilterBrandFilterResolvedFragment = ItemProductSearchFilterBrandFilterResolved_EntitySearchTextFilter_Fragment | ItemProductSearchFilterBrandFilterResolved_EntitySearchTextInFilter_Fragment;

export type ItemProductSearchFilterBrandLineFilter_EntitySearchTextFilter_Fragment = { __typename: 'EntitySearchTextFilter', valueText?: string | null, operatorText: Types.EntitySearchTextFilterOperator };

export type ItemProductSearchFilterBrandLineFilter_EntitySearchTextFilterComputed_Fragment = { __typename: 'EntitySearchTextFilterComputed', operatorText: Types.EntitySearchTextFilterOperator, expr: string, missingValue: boolean, valueTextComputed?: string | null };

export type ItemProductSearchFilterBrandLineFilter_EntitySearchTextInFilter_Fragment = { __typename: 'EntitySearchTextInFilter', valueTextIn?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator };

export type ItemProductSearchFilterBrandLineFilter_EntitySearchTextInFilterComputed_Fragment = { __typename: 'EntitySearchTextInFilterComputed', operatorTextIn: Types.EntitySearchTextInFilterOperator, expr: string, missingValue: boolean, valueTextInComputed?: Array<string> | null };

export type ItemProductSearchFilterBrandLineFilterFragment = ItemProductSearchFilterBrandLineFilter_EntitySearchTextFilter_Fragment | ItemProductSearchFilterBrandLineFilter_EntitySearchTextFilterComputed_Fragment | ItemProductSearchFilterBrandLineFilter_EntitySearchTextInFilter_Fragment | ItemProductSearchFilterBrandLineFilter_EntitySearchTextInFilterComputed_Fragment;

export type ItemProductSearchFilterBrandLineFilterResolved_EntitySearchTextFilter_Fragment = { __typename: 'EntitySearchTextFilter', valueText?: string | null, operatorText: Types.EntitySearchTextFilterOperator };

export type ItemProductSearchFilterBrandLineFilterResolved_EntitySearchTextInFilter_Fragment = { __typename: 'EntitySearchTextInFilter', valueTextIn?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator };

export type ItemProductSearchFilterBrandLineFilterResolvedFragment = ItemProductSearchFilterBrandLineFilterResolved_EntitySearchTextFilter_Fragment | ItemProductSearchFilterBrandLineFilterResolved_EntitySearchTextInFilter_Fragment;

export type ItemProductSearchFilterFavouritesFilter_EntitySearchBoolFilter_Fragment = { __typename: 'EntitySearchBoolFilter', valueBool?: boolean | null, operatorBool: Types.EntitySearchBoolFilterOperator };

export type ItemProductSearchFilterFavouritesFilter_EntitySearchBoolFilterComputed_Fragment = { __typename: 'EntitySearchBoolFilterComputed', operatorBool: Types.EntitySearchBoolFilterOperator, expr: string, missingValue: boolean, valueBoolComputed?: boolean | null };

export type ItemProductSearchFilterFavouritesFilterFragment = ItemProductSearchFilterFavouritesFilter_EntitySearchBoolFilter_Fragment | ItemProductSearchFilterFavouritesFilter_EntitySearchBoolFilterComputed_Fragment;

export type ItemProductSearchFilterFavouritesFilterResolvedFragment = { __typename: 'EntitySearchBoolFilter', valueBool?: boolean | null, operatorBool: Types.EntitySearchBoolFilterOperator };

export const ItemProductSearchFilterFavouritesFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterFavouritesFilter on ItemProductSearchFilterFavouritesFilter {
  ... on EntitySearchBoolFilter {
    valueBool
    operatorBool
  }
  ... on EntitySearchBoolFilterComputed {
    operatorBool
    expr
    missingValue
    valueBoolComputed
  }
}
    `;
export const ItemProductSearchIdFilterFragmentDoc = gql`
    fragment ItemProductSearchIdFilter on EntitySearchIdFilter {
  valueId
  operatorId
}
    `;
export const ItemProductSearchFilterIdFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterIdFilter on ItemProductSearchFilterIdFilter {
  ...ItemProductSearchIdFilter
  ... on EntitySearchIdInFilter {
    valueIdIn
    operatorIdIn
  }
}
    ${ItemProductSearchIdFilterFragmentDoc}`;
export const ItemProductSearchFilterBrandFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandFilter on ItemProductSearchFilterBrandFilter {
  ... on EntitySearchTextFilter {
    valueText
    operatorText
  }
  ... on EntitySearchTextInFilter {
    valueTextIn
    operatorTextIn
  }
  ... on EntitySearchTextFilterComputed {
    operatorText
    expr
    missingValue
    valueTextComputed
  }
  ... on EntitySearchTextInFilterComputed {
    operatorTextIn
    expr
    missingValue
    valueTextInComputed
  }
}
    `;
export const ItemProductSearchFilterBrandLineFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandLineFilter on ItemProductSearchFilterBrandLineFilter {
  ... on EntitySearchTextFilter {
    valueText
    operatorText
  }
  ... on EntitySearchTextInFilter {
    valueTextIn
    operatorTextIn
  }
  ... on EntitySearchTextFilterComputed {
    operatorText
    expr
    missingValue
    valueTextComputed
  }
  ... on EntitySearchTextInFilterComputed {
    operatorTextIn
    expr
    missingValue
    valueTextInComputed
  }
}
    `;
export const ItemProductSearchFilterPriceFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterPriceFilter on ItemProductSearchFilterPriceFilter {
  ... on EntitySearchNumberFilter {
    operatorNumber
    valueNumber
  }
  ... on EntitySearchNumberBetweenFilter {
    operatorNumberBetween
    valueNumberBetween {
      min
      max
    }
  }
  ... on EntitySearchNumberFilterComputed {
    operatorNumber
    expr
    missingValue
    valueNumberComputed
  }
  ... on EntitySearchNumberBetweenFilterComputed {
    operatorNumberBetween
    expr
    missingValue
    valueNumberBetweenComputed {
      min
      max
    }
  }
}
    `;
export const ItemProductSearchFilterDefinitionsFragmentDoc = gql`
    fragment ItemProductSearchFilterDefinitions on ItemProductSearchFilterDefinitions {
  itemId
  favouritesFilter {
    ...ItemProductSearchFilterFavouritesFilter
  }
  productTypeIdFilter {
    ...ItemProductSearchIdFilter
  }
  supplierIdFilter {
    ...ItemProductSearchFilterIdFilter
  }
  brandFilter {
    ...ItemProductSearchFilterBrandFilter
  }
  brandLineFilter {
    ...ItemProductSearchFilterBrandLineFilter
  }
  listPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  netPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  propertyFilters {
    ...ItemProductSearchFilterPropertyFilter
  }
}
    ${ItemProductSearchFilterFavouritesFilterFragmentDoc}
${ItemProductSearchIdFilterFragmentDoc}
${ItemProductSearchFilterIdFilterFragmentDoc}
${ItemProductSearchFilterBrandFilterFragmentDoc}
${ItemProductSearchFilterBrandLineFilterFragmentDoc}
${ItemProductSearchFilterPriceFilterFragmentDoc}
${ItemProductSearchFilterPropertyFilterFragmentDoc}`;
export const ItemProductSearchFilterFavouritesFilterResolvedFragmentDoc = gql`
    fragment ItemProductSearchFilterFavouritesFilterResolved on ItemProductSearchFilterFavouritesFilterResolved {
  ... on EntitySearchBoolFilter {
    valueBool
    operatorBool
  }
}
    `;
export const ItemProductSearchFilterBrandFilterResolvedFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandFilterResolved on ItemProductSearchFilterBrandFilterResolved {
  ... on EntitySearchTextFilter {
    valueText
    operatorText
  }
  ... on EntitySearchTextInFilter {
    valueTextIn
    operatorTextIn
  }
}
    `;
export const ItemProductSearchFilterBrandLineFilterResolvedFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandLineFilterResolved on ItemProductSearchFilterBrandLineFilterResolved {
  ... on EntitySearchTextFilter {
    valueText
    operatorText
  }
  ... on EntitySearchTextInFilter {
    valueTextIn
    operatorTextIn
  }
}
    `;
export const ItemProductSearchFilterPriceFilterResolvedFragmentDoc = gql`
    fragment ItemProductSearchFilterPriceFilterResolved on ItemProductSearchFilterPriceFilterResolved {
  ... on EntitySearchNumberFilter {
    operatorNumber
    valueNumber
  }
  ... on EntitySearchNumberBetweenFilter {
    operatorNumberBetween
    valueNumberBetween {
      min
      max
    }
  }
}
    `;
export const ItemProductSearchFilterDefaultsFragmentDoc = gql`
    fragment ItemProductSearchFilterDefaults on ItemProductSearchFilterDefaults {
  itemId
  favouritesFilter {
    ...ItemProductSearchFilterFavouritesFilterResolved
  }
  productTypeIdFilter {
    ...ItemProductSearchIdFilter
  }
  supplierIdFilter {
    ...ItemProductSearchFilterIdFilter
  }
  brandFilter {
    ...ItemProductSearchFilterBrandFilterResolved
  }
  brandLineFilter {
    ...ItemProductSearchFilterBrandLineFilterResolved
  }
  listPriceFilter {
    ...ItemProductSearchFilterPriceFilterResolved
  }
  netPriceFilter {
    ...ItemProductSearchFilterPriceFilterResolved
  }
  propertyFilters {
    ...ItemProductSearchFilterPropertyFilterResolved
  }
}
    ${ItemProductSearchFilterFavouritesFilterResolvedFragmentDoc}
${ItemProductSearchIdFilterFragmentDoc}
${ItemProductSearchFilterIdFilterFragmentDoc}
${ItemProductSearchFilterBrandFilterResolvedFragmentDoc}
${ItemProductSearchFilterBrandLineFilterResolvedFragmentDoc}
${ItemProductSearchFilterPriceFilterResolvedFragmentDoc}
${ItemProductSearchFilterPropertyFilterResolvedFragmentDoc}`;